export default __webpack_public_path__ + "static/media/placeHolderImage.77d7ec1d.png";